import { LockRounded } from "@mui/icons-material";
import { Box, Button, Typography, useTheme } from "@mui/material";
import { Link } from "react-router-dom";

export default function SubscriptionInActive () {
    const theme = useTheme();
    return(
        <Box sx={{display:"flex", flexDirection:"column", justifyContent:'center', alignItems:'center', height:'100%'}}>
            <LockRounded sx={{ fontSize: 80, color: "grey" }}/>
            <Typography variant="h5" fontWeight={500} color={theme.palette.neutral.normal}>
                Your subscription has expired.
            </Typography>
            <Typography variant="h6" fontWeight={400} color={theme.palette.neutral.normal}>
                Please renew your subscription to continue using the service!
            </Typography>
             {/* BUTTON TO SUBSCRIPTION PAGE */}
            <Button 
                variant="contained"
                component={Link}
                to="/home/subscription"
                sx={{ mt: 2 }}
            >
                Renew Subscription
            </Button>
        </Box>
    );
}